import { useCallback } from "react";
import { useRouter } from "expo-router";

export function useBack(fallbackHref = "/") {
  const router = useRouter();

  return useCallback(() => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace(fallbackHref as never);
    }
  }, [router, fallbackHref]);
}
